import React, { useState, useEffect } from "react";
import "../styles/Formularios.css";
import { useGlobal } from "../context/ContenedorGlobal";
import InputGenerico from "./InputGenerico";
import InputSelectEstados from "./InputSelectEstados";
import { useApiFetch } from "../utils/apiFetch";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../assets/logo_sict.png";
import InputNombrePuertoPp from "./InputNombrePuertoPp";
import InputNombrePuertoSw from "./InputNombrePuertoSw";
import InputBienesAutocomplete from "./InputBienesAutocomplete";


function ModificarPuertosPatch() {
    const { setModuloActual, setSubModuloActual, elementoSeleccionado, setElementoSeleccionado, logout } = useGlobal();
    const apiFetch = useApiFetch();
    const [arrayPuertosPp, setArrayPuertosPp] = useState([]);
    const [nomTabla, setNomTabla] = useState(elementoSeleccionado.patch);
    const [puertoPp, setPuertoPp] = useState("");
    const [idEstado, setIdEstado] = useState("");
    const [estado, setEstado] = useState("");
    const [puertoSw, setPuertoSw] = useState("");
    const [nodo, setNodo] = useState("");
    const [serieBien, setSerieBien] = useState("");
    const [notasPpp, setNotasPpp] = useState("");
    const [success, setSuccess] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [puertoSeleccionado, setPuertoSeleccionado] = useState(null);
    const [mostrarFormulario, setMostrarFormulario] = useState(false);

    useEffect(() => {
        const fetchPuertos = async () => {
            setLoading(true);
            setError("");
            setSuccess("");

            try {
                if (elementoSeleccionado) {
                    const data = await apiFetch("consultar_puertos_pp.php?patch=" + nomTabla, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" }
                    }, logout);

                    if (data.status === "ok") {
                        setArrayPuertosPp(data.data);
                        setSuccess("Lista de puertos del Patch panel.");
                    } else {
                        setError(data.message || "Error al consultar los puertos.");
                        setTimeout(() => {
                            setModuloActual("Red");
                            setSubModuloActual(null);
                        }, 2000);
                    }
                }
            } catch (err) {
                setError("Error de conexión con el servidor: " + err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchPuertos();
    }, []);

    // Se renderiza puertoSeleccionado con el nuevo valor
    const handleSelect = (pt) => {
        setPuertoSeleccionado(pt);
    }

    // Función para exportar uno o todos los puertos en formato CSV
    const handleExportar = () => {
        let puertosParaExportar = [];

        if (puertoSeleccionado) {
            puertosParaExportar = [puertoSeleccionado];  // Se asigna el objeto "seleccionado" para exportar
        } else {
            puertosParaExportar = arrayPuertosPp;  // Se asigna todo el array de puertos al array de los puertos para exportar
        }

        // Definiendo los encabezados de las columnas para el archivo a exportar
        const headers = [
            "Puerto",
            "Estado",
            "Puerto_sw",
            "Nodo",
            "Serie_Bien"
        ];

        // Convertir a CSV
        const csvRows = [];
        csvRows.push(headers.join(",")); // La primera fila serán los encabezados

        puertosParaExportar.forEach(pt => {   // Las filas siguientes seran el o los puertos que esten en el array puertosParaExportar
            const row = [
                `"${pt.puerto_pp}"`,
                `"${pt.estado}"`,
                `"${pt.puerto_sw}"`,
                `"${pt.nodo}"`,
                `"${pt.serie_bien}"`
            ];
            csvRows.push(row.join(","));
        });

        const csvString = csvRows.join("\n");

        // Crear archivo descargable
        const BOM = "\uFEFF"; // Marca de Orden de Bytes para UTF-8
        const blob = new Blob([BOM + csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "puertos_pp.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Función para exportar en PDF
    const handleExportarPDF = () => {
        let puertosParaExportar = [];

        if (puertoSeleccionado) {
            puertosParaExportar = [puertoSeleccionado]; // solo el seleccionado
        } else {
            puertosParaExportar = arrayPuertosPp; // toda la lista
        }

        const doc = new jsPDF();

        // Logo institucional
        doc.addImage(logo, "PNG", 10, 10, 30, 15);

        // Encabezado
        doc.setFontSize(14);
        doc.text("Secretaría de Infraestructura, Comunicaciones y Transportes", 50, 20);
        doc.setFontSize(12);
        doc.text(`Listado de Puertos del Patch Panel ${nomTabla}`, 50, 30);

        doc.setLineWidth(0.5);
        doc.line(10, 40, 200, 40);

        // Tabla
        autoTable(doc, {
            startY: 50,
            head: [["Puerto", "Estado", "Puerto SW", "Nodo", "Serie Bien", "Notas"]],
            body: puertosParaExportar.map(pt => [
                pt.puerto_pp,
                pt.estado,
                pt.puerto_sw,
                pt.nodo,
                pt.serie_bien,
                pt.notas_puerto_pp || ""
            ])
        });

        // Pie de página
        doc.setFontSize(10);
        doc.text("© 2025-2026 SIGBI-712. Todos los derechos reservados.", 10, 290);

        // Nombre dinámico del archivo
        const nombreArchivo = puertoSeleccionado
            ? `puerto_${puertoSeleccionado.puerto_pp}.pdf`
            : `puertos_${nomTabla}.pdf`;

        doc.save(nombreArchivo);
    };

    // Función para desmarcar
    const handleDesmarcar = () => {
        setPuertoSeleccionado(null);
    };

    // Función para mostrar el formulario para modificar un puerto
    const handleModificar = () => {
        if (!puertoSeleccionado) {
            alert("Por favor selecciona un puerto para modificar.");
            return;
        }
        setMostrarFormulario(true);
    };


    const handleCancelar = () => {
        setMostrarFormulario(false);
        setPuertoSeleccionado(null);
    };

    // Efecto de sincronización de estado del puertoSeleccionado
    useEffect(() => {
        if (puertoSeleccionado) {
            setPuertoPp(puertoSeleccionado.puerto_pp || "");
            setIdEstado(puertoSeleccionado.id_estado || "");
            setPuertoSw(puertoSeleccionado.puerto_sw || "");
            setNodo(puertoSeleccionado.nodo || "");
            setSerieBien(puertoSeleccionado.serie_bien || "");
            setNotasPpp(puertoSeleccionado.notas_puerto_pp)
            setEstado(puertoSeleccionado.estado || "");
        }
    }, [puertoSeleccionado]);

    // Función handleSubmit para modificar el puerto
    const handleModificarPuerto = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        setSuccess("");

        try {
            const data = await apiFetch("modificar_puertos_pp.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    patch: nomTabla,
                    puerto_pp: puertoPp,
                    id_estado: idEstado,
                    puerto_sw: puertoSw,
                    nodo,
                    serie_bien: serieBien,
                    notas_puerto_pp: notasPpp
                })
            }, logout);

            if (data.status === "ok") {
                setSuccess("Puerto modificado correctamente.");
                setTimeout(() => {
                    setModuloActual("Red");
                    setSubModuloActual(null);
                }, 2000);
            } else {
                setError(data.message || "Error al modificar el puerto.");
            }
        } catch (err) {
            setError("Error de conexión con el servidor: " + err.message);
        } finally {
            setLoading(false);
        }
    };

    // Función para resetear los mensajes después de un tiempo
    useEffect(() => {
        if (error || success) {
            const timer = setTimeout(() => {
                setError("");
                setSuccess("");
            }, 2000);

            return () => clearTimeout(timer); // limpiar si cambia antes de los 2s
        }
    }, [error, success]);

    return (
        <div>
            {!mostrarFormulario ? (

                <div className="sesion-form">
                    {loading && <p>Cargando puertos...</p>}
                    {error && <p className="error">{error}</p>}
                    {success && <p className="success">{success}</p>}

                    {arrayPuertosPp.length > 0 && (
                        <table className="tabla-estandar seleccion-unica">
                            <thead>
                                <tr>
                                    <th>Seleccionar</th>
                                    <th>Puerto</th>
                                    <th>Estado</th>
                                    <th>Puerto Sw</th>
                                    <th>Nodo</th>
                                    <th>Serie Bien</th>
                                </tr>
                            </thead>
                            <tbody>
                                {arrayPuertosPp.map((pt, index) => (
                                    <tr key={index}>
                                        <td data-label="Seleccionar">
                                            <input
                                                type="checkbox"
                                                checked={puertoSeleccionado?.puerto_pp === pt.puerto_pp}
                                                onChange={() => handleSelect(pt)}
                                            />
                                        </td>
                                        <td data-label="Puerto Patch">{pt.puerto_pp}</td>
                                        <td data-label="Estado">{pt.estado}</td>
                                        <td data-label="Puerto Switch">{pt.puerto_sw}</td>
                                        <td data-label="Nodo">{pt.nodo}</td>
                                        <td data-label="Serie Bien">{pt.serie_bien}</td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}

                    {arrayPuertosPp.length > 0 && (
                        <div className="form-buttons">
                            <button type="button" onClick={handleModificar} disabled={!puertoSeleccionado}>Modificar<br></br>puerto</button>
                            <button type="button" onClick={handleExportar}>Exportar<br></br>en CSV</button>
                            <button type="button" onClick={handleExportarPDF}>Exportar<br></br>en PDF</button>
                            <button type="button" onClick={handleDesmarcar} disabled={!puertoSeleccionado}>Desmarcar</button>
                        </div>
                    )}

                </div>

            ) : (

                <div className="sesion-form">

                    {success && <div className="success">Datos del puerto modificados correctamente</div>}
                    {error && <div className="error">{error}</div>}

                    <form onSubmit={handleModificarPuerto}>

                        <InputNombrePuertoPp
                            value={puertoPp}
                            setValue={setPuertoPp}
                            label="Nombre del puerto patch panel"
                            title="Formato: pp1_ep_p1_10, máximo 12 caracteres."
                            readOnly={true}
                        />

                        <InputSelectEstados
                            idEstado={idEstado}
                            setIdEstado={setIdEstado}
                            estadoActualText={estado}
                            idEntidad={6}
                            label="Estado del puerto"
                            apiUrl={`consultar_estados.php`}
                        />

                        <InputNombrePuertoSw
                            value={puertoSw}
                            setValue={setPuertoSw}
                            label="Nombre del puerto switch"
                            title="Formato: sw1_ep_p1_10, máximo 12 caracteres."
                        />

                        <InputGenerico
                            value={nodo}
                            setValue={setNodo}
                            label="Nodo"
                            maxLength={3}
                            allowedChars="0-9"
                            transform="uppercase"
                            placeholder="101"
                            title="Respete la nomenclatura 1, 21, 331"
                        />

                        <InputBienesAutocomplete
                            idSeleccionado={serieBien}
                            setIdSeleccionado={setSerieBien}
                            label={`Serie conectada: ${puertoSeleccionado.serie_bien}`}
                            placeholder="Nueva serie: "
                            title="Máximo 30 caracteres"
                            readOnly={false}
                            maxLength={30}
                        />

                        <InputGenerico
                            value={notasPpp}
                            setValue={setNotasPpp}
                            label="Notas del puerto"
                            readOnly={false}
                            maxLength={255}
                            placeholder="Escriba su texto aquí"
                            title="Máximo 255 caracteres"
                        />

                        <div className="form-buttons">
                            <button type="submit">Modificar</button>
                            <button type="botton" onClick={handleCancelar} >Cancelar</button>
                        </div>
                    </form>

                </div>

            )}
        </div>
    );
}

export default ModificarPuertosPatch;